// extracted by mini-css-extract-plugin
module.exports = {"content":"EmailVerificationPrompt_content__3u8V7","actions":"EmailVerificationPrompt_actions__2i15K","fullWidth":"EmailVerificationPrompt_fullWidth__2EYF1"};